
export const root = {
    background: '{surface.card}',
    borderColor: '{surface.border}',
    borderRadius: '{border.radius.md}',
    color: '{text.color}',
    borderWidth: '1px'
};

export const header = {
    borderWidth: '0 0 1px 0',
    borderColor: '{surface.border}',
    padding: '1rem',
    borderRadius: '{border.radius.md} {border.radius.md} 0 0',
    background: '{surface.card}',
    color: '{text.color}',
    fontWeight: '{font.weight.semibold}'
};

export const toggleableHeader = {
    padding: '0.25rem 1.125rem'
};

export const title = {
    fontWeight: '700'
};

export const content = {
    padding: '1rem'
};

export const footer = {
    padding: '1rem'
};

export const colorScheme = {
    light: {
        header: {
            background: '{surface.50}',
            color: '{text.color}'
        }
    },
    dark: {
        header: {
            background: '{surface.800}',
            color: '{text.color}'
        }
    }
};

export default {
    root,
    header,
    toggleableHeader,
    title,
    content,
    footer,
    colorScheme
};
